import {Injectable, inject} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {map, switchMap} from 'rxjs/operators';
import {UserService} from '../services/user.service';
import {AuthenticationService} from './authentication.service';
import {OrganisationService} from "../services/organisation.service";
import {from, of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuardService  {

  private authService = inject(AuthenticationService);
  private userService = inject(UserService);
  private organisationService = inject(OrganisationService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Wait for the initial session check to settle before reading isAuthenticated() - on a
    // fresh app bootstrap (e.g. a hard navigation straight into a protected route) the signal
    // still has its default false value until getCurrentUser() resolves, so checking it
    // synchronously here can incorrectly block an already-authenticated user.
    return from(this.authService.authReady).pipe(
      switchMap(() => {
        if (!this.authService.isAuthenticated()) {
          return of(false);
        }

        return this.userService.getUserPolicies().pipe(
          map(policies => {
            const requiresPermission = !!route.data.permission;

            // // Log if error
            // if (requiresPermission && !policies.includes(route.data.permission)) {
            //   console.error('Attempted to load route', route, 'without required permission', route.data.permission);
            //   console.error('User has these permissions:', policies);
            // }

            return requiresPermission ? policies.includes(route.data.permission) : true;
          }),
          switchMap(can => {

              if (!can) {
                return of(can);
              }

              if (route.data.isActiveOrganisation) {
                return this.organisationService.getOrganisation().pipe(
                  switchMap(org => {
                    return of(!org.isDeactivated && !org.isTrialExpired);
                  })
                )
              }

              return of(can);
            }
          )
        );
      })
    );
  }

}
